export const WORKER_MANDATE = `
# Worker Mandate

- Implement the assigned scope with minimal, tested edits.
- Preserve public contracts unless Commander explicitly assigns a behavior change.
- Return enough evidence for Reviewer to reproduce the validation path.
`;
